import { AlarmRow } from "@src/cloud-connect/alarms/entities/alarm-row";
import { reverseTranslateCondition } from "./reverse-translate-condition";
import { Condition } from "../../../cloud-connect/alarms/entities/condition";
import { getAlarmProfiles } from "../../../cloud-connect/dependency-injection-container/get-alarm-profiles";

const createCondition = (user_input: string | number, operator: string) =>
  new Condition(user_input, false, reverseTranslateCondition(operator));

export const createConditions = (
  firstCondition: string | number,
  secondCondition: string | number,
  firstOperator: string,
  secondOperator: string,
) => {
  const conditions = [];

  if (firstCondition !== "") {
    conditions.push(createCondition(firstCondition, firstOperator));
  }

  if (secondCondition !== "") {
    conditions.push(createCondition(secondCondition, secondOperator));
  }

  return conditions;
};

export const handleConditionOnBlur = (
  alarmRow: AlarmRow,
  firstCondition: string | number,
  secondCondition: string | number,
  firstOperator: string,
  secondOperator: string,
) => {
  const conditions = createConditions(
    firstCondition,
    secondCondition,
    firstOperator,
    secondOperator,
  );

  alarmRow.getAlarm().getCriteria().setConditions(conditions);

  const oldAlarms = getAlarmProfiles().getActiveAlarmProfile().getAlarms();

  getAlarmProfiles()
    .getActiveAlarmProfile()
    .setAlarms([...oldAlarms, alarmRow.getAlarm()]);
};
